import { toast, cssTransition } from "react-toastify";

const FILE_LOADING_MSG = "You file if loading... Please wait";
const FILE_SUCCESS_MSG = "You file uploaded!";

const props = {
  type: "success" | "error" | "info" | "warning",
  text: " ",
};


export const notify = ({type, text}) => {
  toast.configure();
  switch (type) {
    case "success": {
      toast.success(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      break;
    }
    case "error": {
      toast.error(text, {
        position: "top-center",
        hideProgressBar: false,
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      break;
    }
    case "warning": {
      toast.warning(text, {
        position: "top-center",
        hideProgressBar: false,
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      break;
    }

    default: {
      toast.info(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      break;
    }
  }
  return null;
};

// export const bounce = cssTransition({
//   enter: "animate__animated animate__bounceIn",
//   exit: "animate__animated animate__bounceOut",
// });

// const swirl = cssTransition({
//   enter: "swirl-in-fwd",
//   exit: "swirl-out-bck",
// });
// export const uploadInfo = () => {
//   toast.info(FILE_LOADING_MSG, { position: toast.POSITION.TOP_CENTER, toastId: "upload-info" });
// };

// export const uploadSuccess = () => {
//   toast.info(FILE_SUCCESS_MSG, { position: toast.POSITION.TOP_CENTER, toastId: "upload-sucess" });
// };
// export const uploadError = () => {
//   toast.error( { position: toast.POSITION.TOP_CENTER });
// };
